import { ObjectAny } from '@lib/interfaces';

export default function removeObjectEmptyProps(obj: ObjectAny): object {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v));
}
